
import React, { useEffect, useState } from 'react';
import qs from "query-string";
import { DATADOG_LOG_TYPE, datadogLogger, encodeText } from '../../../helpers/utilCommon';
import { clearAppSession, authClient, handleLoggedIn } from 'helpers/OktaUtility';
import { get } from 'lodash';
import { memberLoginAction } from 'services/userServices';
import { useDispatch } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react';
import { cookieKeysEnum, LOGIN_USER_MODEL } from 'models/common.models';
import { getCookie } from 'helpers/manageCookies';
import { setMiniAppLoader } from 'redux/app/actions';
import { restoreOktaSession } from 'helpers/OktaSessionRestore';

const RegistraionComponent = (props) => {
    const [getAccountInfo, setAccountInfo] = useState(null);
    const userInfo = props?.userInfo;
    const accountNumber = get(userInfo, 'memberAccountNumber');
    const dispatch = useDispatch();
    const { authState } = useOktaAuth();

    const memberLoginHandler = (callback) => {
      if (authState?.idToken?.claims) {
        dispatch(setMiniAppLoader(true));
        let memberData = {
          userInfo: authState.idToken.claims,
          request_mode: LOGIN_USER_MODEL.MEMBER_LOGIN,
        };
        memberLoginAction(memberData, dispatch, () => {
          dispatch(setMiniAppLoader(true));
          callback();
        });
      } else {
        clearAppSession(true);
     }
    };

    const getQueryStringValue = (
        key,
        queryString = window.location.search
    ) => {
        const values = qs.parse(queryString);
        return values[key];
    };

    const bridgeApiHandler = (accountNumber) => {
        let eventid = getQueryStringValue('eventid');
        let categoryid = getQueryStringValue('categoryid');
        let isMember = get(userInfo, 'isMember');
        let data = {};
        data.eventid = eventid;            
        setAccountInfo(accountNumber);
        data.isMember=isMember;            
        if(isMember){
            data.accountNumber = encodeText(accountNumber);                        
        } else {
            data.email = get(userInfo, 'email');
            data.firstName = get(userInfo, 'firstName');
            data.lastName = get(userInfo, 'lastName');                
        }
        const bridgeAPIHandler = () => {
          props.postDataToBridgeAPI(data, (responseBridgeAPI) => {
              if (responseBridgeAPI && eventid && categoryid) {
                  window.location.assign(`${process.env.REACT_APP_AVENTRI_REDIRECT_URL}?eventid=${eventid}&categoryid=${categoryid}&bridgeid=${responseBridgeAPI}`);
              } else if (responseBridgeAPI && eventid) {
                  window.location.assign(`${process.env.REACT_APP_AVENTRI_REDIRECT_URL}?eventid=${eventid}&bridgeid=${responseBridgeAPI}`);
              } else {
                datadogLogger(
                    `Aventri redirect issue`,
                    {
                        bridgeId: responseBridgeAPI ?? "",
                        eventId: eventid ?? "",
                        categoryId: categoryid ?? ""
                    },
                    DATADOG_LOG_TYPE.error,
                    {
                        errro : "Aventri redirect issue"
                    }
                );
            }
          });
        };
        if (getCookie(cookieKeysEnum["APP_SESSIONID"])) {
            bridgeAPIHandler();
        } else { 
            memberLoginHandler(bridgeAPIHandler);
        }
    }

    useEffect(() => {
      // Check User Is Login
      (async () => {
        const isSessionExist = await authClient.session.exists();
        if (accountNumber && isSessionExist) {
            const callbackHandler = (response) => {
            if (response) {
              bridgeApiHandler(accountNumber);
            }
          };
          const oktaProps = {
            oktaAuth: authClient,
            callback: callbackHandler,
            errorHandler: clearAppSession
          };
          restoreOktaSession(oktaProps);
        } else {
            const hasUserInfo = localStorage.getItem("user-info");
            clearAppSession(hasUserInfo ? true : false);
        }
      })();
    }, [accountNumber]);

    const handle_NonMemberClick = () => {
        let eventid = getQueryStringValue('eventid');
        let categoryid = getQueryStringValue('categoryid');
        if (eventid && categoryid)
            window.location.assign(`${process.env.REACT_APP_AVENTRI_REDIRECT_URL}?eventid=${eventid}&categoryid=${categoryid}`);
        else if (eventid)
            window.location.assign(`${process.env.REACT_APP_AVENTRI_REDIRECT_URL}?eventid=${eventid}`);
    }

    const handle_MemberLoginClick = () => {
        const redirectURL = window.location.href.replace(/.*\/\/[^\/]*/, '');
        handleLoggedIn(redirectURL);
    }

    return (
        <>
            {getAccountInfo ? <div style={{ height: 400 }} data-testid="aventriRegLoggedCom"></div> : <div className="container" data-testid="aventriRegGuestCom">
                <div className="publicLogin">
                    <div className="page-title-wrapper">
                        <h1 className="page-title astm-type-heading--h1">Member/Registered User Login</h1>
                    </div>

                    <div className="astm-type-body--lead">
                        <h4 className="astm-type-heading--h4">Member/Registered Users</h4>
                        <p className="astm-type-body--lead">If you have already registered an account as a Member or Registered user (Non-Member), please proceed to sign in.</p>
                        <div className="actions-toolbar" onClick={handle_MemberLoginClick}>
                            <a href="#" className="btn astm-btn btn-primary w-100" data-testid="signin_btn">Sign In</a>
                        </div>
                    </div>
                    <div className="solid-border"></div>
                    <div>
                        <h4 className="astm-type-heading--h4">Non-Members</h4>
                        <div className="astm-type-body--lead" aria-labelledby="block-new-customer-heading">
                            <p className="astm-type-body--lead">If you do not  have a member/registered user account with ASTM and wish to Register for an Event, please proceed to Pre-Register as a Non-Member</p>
                            <div className="actions-toolbar" onClick={handle_NonMemberClick}>
                                <a href="#" className="btn astm-btn btn-secondary w-100" data-testid="guest_btn">Pre-Register as a Non-Member</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    );
}
export default RegistraionComponent;
